let  BASE_URL = "https://mern-project-three33-coral.vercel.app/" || "http://localhost:4000/";

export { BASE_URL };
